var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0H3C1.34315 0 0 1.34315 0 3V11C0 12.6569 1.34315 14 3 14H4V0ZM5 14H11C12.6569 14 14 12.6569 14 11V10H5V14ZM14 9V3C14 1.34315 12.6569 0 11 0H5V9H14Z",
    fill: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavListIcon);
export default __webpack_public_path__ + "static/media/sidenav-list-icon.935d6d6c6c0024e66ed7454f04754646.svg";
export { ForwardRef as ReactComponent };